import type { FaireProductEntity } from "../../entity_types/product";

export const p_49h9unzavy: FaireProductEntity = {
  token: "p_49h9unzavy",
  type: "product",
  name: "Sedona Thunderbird Unisex T-Shirt",
  brandToken: "b_fdmfz6yamg",
  brandName: "Vortex Visions Design",
  imageUrl:
    "https://cdn.faire.com/fastly/91cfe1115b54c3ff9935a962bf05cecdbc9cd6cf0103674b48b712f8e3780a05.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6714efd8c4837da1e4d53b7d6c41370519dc8a8116a244bf3817e774a3d463fe.png",
    "https://cdn.faire.com/fastly/ad75eda91f4a122b2909ecc7991f9b524202466bd1a860356f51f20bb97662a4.png",
    "https://cdn.faire.com/fastly/63e00e498ecb3b7e70f9073417b197c8ec30c1840bfb416a19d9e03c3ec4ea99.png",
  ],
  priceDollars: 16.63,
  description:
    "Introducing our customizable unisex tee featuring the iconic Thunderbird design featuring the beautiful Sedona, Arizona. This tee pays homage to the Southwest's cultural heritage. With its classic fit and customizable option, it's perfect for anyone seeking comfort and style. From casual outings to urban flair, this tee is a versatile addition to your wardrobe, celebrating the mystique of Sedona and the Southwest's natural beauty. Add your personal touch to this durable and stylish tee, embracing the region's rich cultural tapestry.\n\nOrder Now: Add a touch of mysticism to your wardrobe and click \"Shop Now\" to choose your favorite color of the Sedona Thunderbird T-Shirt. \n\nCUSTOMIZATION AVAILABLE! Not from Sedona? We offer customization of this design to change the location to fit your retail location needs. ",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:53.583Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
